import { useState } from "react";

export default function usePagination(pageSize?: number) {

    const [totalRecords, setTotalRecords] = useState<number>(0)
    const [paginationParams, setPaginationParams] = useState<TPaginationParams>({ per_page: pageSize ?? 10, page: 1, })
    const updatePageSize = (pageSize: number) => {
        setPaginationParams((prevState: TPaginationParams) => ({
            ...prevState,
            page: 1,
            per_page: pageSize,
        }));
    };

    const handlePageChange = (pageNumber: number) => {
        setPaginationParams((prevState: TPaginationParams) => ({
            ...prevState,
            page: pageNumber,
        }));
    }

    const updateTotalRecords = (e: number) => {
        setTotalRecords(e)
    }

    return {
        totalRecords,
        updateTotalRecords,
        paginationParams,
        handlePageChange,
        updatePageSize
    }
}